<template>

  <!-- Page Menu -->
  <q-toolbar
    class="page-menu"
    v-if="items.length"
    :class="{'no-hidden': noHidden}">

    <universal-link
      :key="index"
      :to="item.link"
      :class="item.class"
      :target="item.target"
      class="page-menu__item"
      v-for="(item, index) in items"
      v-if="!item.position || item.position === 'header'">

      <q-btn
        flat
        stretch
        no-caps
        :label="item.title.ru"/>

    </universal-link>

    <q-btn
      flat
      stretch
      v-if="!noDots"
      icon="fa lni-more"
      @click="$emit('expand')"
      class="page-menu__item md"/>

  </q-toolbar>

</template>

<script>

  export default {
    name: 'page-menu',
    props: {
      items: {
        type: Array,
        default: () => [],
      },
      noHidden: {
        type: Boolean,
        default: false,
      },
      noDots: {
        type: Boolean,
        default: false,
      },
    },
  };

</script>

<style lang="scss">

  .page-menu {
    height: 100%;
    flex-basis: 0;
    background-color: transparent;

    &__item {
      align-self: stretch;
      display: inline-flex;
    }

    &__item > .q-btn {
      height: 100%;
      font-weight: bold;
      white-space: nowrap;
    }

    &.no-hidden > .page-menu__item {
      display: block !important;
    }
  }

</style>
